/** Whether a string is a `#RRGGBB` hex color (six hex digits, either case). */
export function isValidHexColor(color: string): boolean {
    return /^#[0-9A-Fa-f]{6}$/.test(color);
}
